module.exports = __webpack_public_path__ + "static/media/Deli_Check.32f4ae14.svg";